module.exports = __webpack_public_path__ + "media/images/favicons/favicon-saturday-16x16-1fa335be6b633f76c23f9f77a2bb6bab.png";